export const drawerWidth = 360;

export const WICHI_MAPOPTION_KEY = 'WICHI-MAP-OPTIONS-KEY';

export const API_HOST = 'https://api.modootel.kr';
